<template>
  <section class="px-5 md:px-12 lg:px-25 grid xl:grid-cols-[25%_1fr] gap-8 md:gap-12 xl:gap-20 transition-[padding_gap]">
    <TitleBlock :subtitle="content.subtitle" :title="content.title" :description="content.description" class="ml-0"/>
    <ul class="grid grid-cols-1 md:grid-cols-2 gap-2.5 lg:gap-6 transition-[gap]">
      <ContentCard v-for="card in content.items" :content="card" :background="content.background" :key="card.flexKey"/>
    </ul>
  </section>
</template>

<script lang="ts">
import {TitleBlock} from '@/components/blocks'
import {ContentCard} from '@/components/cards'

export default {
  name: 'ContentCardsSection',
  components: {ContentCard, TitleBlock},
  props: {
    content: {
      type: Object,
      required: true
    }
  }
}
</script>